module.exports = __webpack_public_path__ + "img/5f6f473bca1cc5dfa636d704.c910058b.png";